import { Tag } from 'antd';

import {
    SupportTicketStatus, SupportTicketStatuses,
} from '@/constants';

type StatusTagProps = {
    status: SupportTicketStatus;
};

const getStatusColor = (status: SupportTicketStatus): string => {
    switch (status) {
        case SupportTicketStatus.New:
            return 'blue';
        case SupportTicketStatus.InProgress:
            return 'orange';
        case SupportTicketStatus.Resolved:
            return 'green';
        default:
            return 'default';
    }
};

export const StatusTag = ({ status }: StatusTagProps) => {
    const color = getStatusColor(status);
    const label = SupportTicketStatuses[status];

    return (
        <Tag color={color}>
            {label}
        </Tag>
    );
};
